import { FC } from 'react'
import Typography from 'components/Typography'
import classNames from 'classnames'
import styles from './Box.module.scss'

export type TBoxProps = {
  title?: string
  description?: string
  onClick?: () => void
  active?: boolean
}

const Box: FC<TBoxProps> = ({ title, description, onClick, active }) => {
  const boxClasses = classNames(styles.ecBox, {
    [styles.ecBoxActive]: active,
  })

  return (
    <div className={boxClasses} onClick={onClick}>
      {title && (
        <Typography variant="Title" bold>
          {title}
        </Typography>
      )}
      {description && (
        <Typography variant="ParagraphSmall" bold>
          {description}
        </Typography>
      )}
    </div>
  )
}

export default Box
